import { SVGProps } from 'react'
const TrashboxIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    className={className}
    {...props}
  >
    <rect width={40} height={40} x={2} y={2} fill="currentColor" rx={20} />
    <rect
      width={40}
      height={40}
      x={2}
      y={2}
      stroke="#494949"
      strokeWidth={3}
      rx={20}
    />
    <path
      fill="#fff"
      d="M28.375 15.75h-3.75v-.938a1.563 1.563 0 0 0-1.563-1.562h-3.125a1.563 1.563 0 0 0-1.562 1.563v.937h-3.75a.624.624 0 1 0 0 1.25h.664l.742 11.91c.056 1.05.86 1.84 1.875 1.84h7.188c1.02 0 1.808-.773 1.875-1.836L27.71 17h.664a.624.624 0 1 0 0-1.25Zm-9.353 12.5H19a.625.625 0 0 1-.625-.603l-.313-8.75a.626.626 0 0 1 1.25-.044l.313 8.75a.627.627 0 0 1-.603.647Zm3.103-.625a.624.624 0 1 1-1.25 0v-8.75a.624.624 0 1 1 1.25 0v8.75Zm1.25-11.875h-3.75v-.938a.309.309 0 0 1 .313-.312h3.125a.309.309 0 0 1 .312.313v.937Zm1.25 11.897a.626.626 0 0 1-.625.603h-.023a.625.625 0 0 1-.602-.647l.313-8.75a.625.625 0 1 1 1.25.044l-.313 8.75Z"
    />
  </svg>
)
export default TrashboxIcon
